let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("isB7h")).then(() => parcelRequire('dFrEV'));